module.exports = __webpack_public_path__ + "static/bg-service-752beb2682d86af0bb3f6d16df5519f2.jpg";